export const isNullOrUndefined = (a?: unknown) => a === undefined || a === null;

export const removeNulls = (obj: object) =>
  Object.entries(obj).reduce(
    (accumulator, [key, value]) =>
      value === null ? accumulator : { ...accumulator, [key]: value },
    {}
  );
